import React from "react";
import heroImg from "../assets/img/COCO.png";
import { useDocument } from "../hooks/useDocument";

const DEFAULTS = {
  heroTitleTh: "ชมรมอนุรักษ์และพัฒนาน้ำมันมะพร้าวแห่งประเทศไทย",
  heroTitleEn: "Conservation and Development of Coconut Oil of Thailand Forum",
  heroSubtitle:
    "เข้าร่วมเป็นสมาชิกชมรมฯกับเราเพื่อรับสิทธิประโยชน์ ในกิจกรรมต่างๆที่ทางชมรมฯจัดขึ้น",
  heroButtonText: "สมัครสมาชิก",
  heroButtonUrl: "https://forms.gle/URBeurvThr4iJvcbA",
};

const Hero = () => {
  const { data } = useDocument("settings", "site");
  const s = { ...DEFAULTS, ...(data || {}) };

  return (
    <section id="hero" className="d-flex align-items-center justify-content-center">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-5 order-2 order-lg-1 d-flex flex-column justify-content-center">
            <h1>{s.heroTitleTh}</h1>
            <h2>{s.heroTitleEn}</h2>
            <h3>{s.heroSubtitle}</h3>
            <div>
              <a
                href={s.heroButtonUrl}
                className="btn-get-started scrollto"
                target="_blank"
                rel="noopener noreferrer"
              >
                {s.heroButtonText}
              </a>
            </div>
          </div>
          <div className="col-lg-7 order-1 order-lg-2 hero-img">
            <img src={heroImg} className="img-fluid animated" alt="Hero" />
          </div>
        </div>
      </div>
      <svg
        className="hero-waves"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
      >
        <defs>
          <path
            id="wave-path"
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
          />
        </defs>
        <g className="wave1">
          <use xlinkHref="#wave-path" x="50" y="3" fill="#725C3A" fillOpacity="0.9" />
        </g>
        <g className="wave2">
          <use xlinkHref="#wave-path" x="50" y="0" fill="#E5D2B8" fillOpacity="0.8" />
        </g>
        <g className="wave3">
          <use xlinkHref="#wave-path" x="50" y="9" fill="#809671" fillOpacity="0.8" />
        </g>
      </svg>
    </section>
  );
};

export default Hero;
